const sendReplyToProtocol = async(params) => {
  const {
          protocol,
          user,
          reply,
        } = params
  
  try {
    return await axios.post(`/protocol/${protocol}/researcher/${user}/reply`, {
      reply,
    })
  } catch (e) {
    throw e
  }
}

const cancelResearcherInvitation = async({
  protocol,
  researcher,
}) => {
  try {
    return await axios.post(
      `/protocol/${protocol}/researcher/${researcher}/remove`)
  } catch (e) {
    throw e
  }
}

const cancelExternalResearcherInvitation = async({
  protocol,
  invitation,
}) => {
  try {
    return await axios.post(
      `/protocol/${protocol}/external/researcher/${invitation}/remove`)
  } catch (e) {
    throw e
  }
}

const addResearcher = async({
  researcher,
  protocol,
}) => {
  try {
    return await axios.post(
      `/protocol/${protocol}/researcher/${researcher}/add`)
  } catch (e) {
    throw e
  }
}

const resendResearcherNotification = async({
  protocol,
  invitation,
}) => {
  try {
    return await axios.post(
      `/protocol/${protocol}/researcher/${invitation}/resend`)
  } catch (e) {
    throw e
  }
}

const resendExternalResearcherNotification = async({
  protocol,
  invitation,
}) => {
  try {
    return await axios.post(
      `/protocol/${protocol}/external/researcher/${invitation}/resend`)
  } catch (e) {
    throw e
  }
}

const reinviteResearcher = async({
  protocol,
  invitation,
}) => {
  try {
    return await axios.post(
      `/protocol/${protocol}/researcher/${invitation}/reinvite`)
  } catch (e) {
    throw e
  }
}

const reinviteExternalResearcher = async({
  protocol,
  invitation,
}) => {
  try {
    return await axios.post(
      `/protocol/${protocol}/external/researcher/${invitation}/reinvite`)
  } catch (e) {
    throw e
  }
}

const sendLeaderEvaluation = async({
  protocol,
  comments,
  status,
}) => {
  try {
    return await axios.post(`/protocol/${protocol}/leader/evaluation`, {
      comments,
      status,
    })
  } catch (e) {
    throw e
  }
}

const fetchProtocolLeaderEvaluation = async(protocol) => {
  try {
    return await axios.get(`/protocol/${protocol}/leader/evaluation`)
  } catch (e) {
    throw e
  }
}

const sendDirectorEvaluation = async({
  protocol,
  comments,
  status,
}) => {
  try {
    return await axios.post(`/protocol/${protocol}/director/evaluation`, {
      comments,
      status,
    })
  } catch (e) {
    throw e
  }
}

const sendProtocolToEvaluationByLeader = async(protocol) => {
  try {
    return await axios.post(`/protocol/${protocol.id}/evaluation/send`)
  } catch (e) {
    throw e
  }
}

const respondProtocolConditionedEvaluation = async({ protocol, committee }) => {
  try {
    return await axios.post(`/protocol/${protocol.id}/${committee.key}/conditioned/send`)
  } catch (e) {
    throw e
  }
}

const saveProtocolFile = async(payload) => {
  try {
    return await axios.post(`/protocol/${payload.get('protocol')}/file`,
      payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  } catch (e) {
    throw e
  }
}

const saveAmendmentFile = async(payload) => {
  try {
    return await axios.post(`/amendment/${payload.get('amendment')}/file`,
      payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  } catch (e) {
    throw e
  }
}

const removeProtocolFile = async({ id }) => {
  try {
    return await axios.delete(`/protocol/${id}/file`)
  } catch (e) {
    throw e
  }
}

const removeAmendmentFile = async({ id }) => {
  try {
    return await axios.delete(`/amendment/${id}/file`)
  } catch (e) {
    throw e
  }
}

const fetchProtocolAttachments = async({ id }) => {
  try {
    return await axios.get(`/protocol/${id}/attachments`)
  } catch (e) {
    throw e
  }
}

const saveProtocolAttachments = async(payload) => {
  try {
    return await axios.post(`/protocol/${payload.get('protocol')}/attachments`,
      payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  } catch (e) {
    throw e
  }
}

const removeProtocolAttachment = async({
  protocol,
  file,
}) => {
  try {
    return await axios.delete(`/protocol/${protocol.id}/attachment/${file.id}`)
  } catch (e) {
    throw e
  }
}

const saveFunders = async({
  protocol,
  funders,
}) => {
  try {
    return await axios.post(`/protocol/${protocol.id}/funders`, {
      funders,
    })
  } catch (e) {
    throw e
  }
}

const removeFunder = async({
  protocol,
  funder,
}) => {
  try {
    return await axios.delete(`/protocol/${protocol.id}/funder/${funder.id}`)
  } catch (e) {
    throw e
  }
}

const saveFunderAgreement = async(payload) => {
  try {
    return await axios.post(
      `/protocol/${payload.get('protocol')}/funder/${payload.get(
        'funder')}/agreement`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  } catch (e) {
    throw e
  }
}

const saveFinancingInformation = async(payload) => {
  try {
    return await axios.post(
      `/protocol/${payload.protocol}/financing-information`, payload)
  } catch (e) {
    throw e
  }
}

const fetchResearchLines = async() => {
  try {
    return await axios.get('/research-lines')
  } catch (e) {
    throw e
  }
}

const assignResearchLine = async({
  protocol,
  research_line,
  type,
}) => {
  try {
    return await axios.post(`/protocol/${protocol.id}/research-line`, {
      research_line,
      type,
    })
  } catch (e) {
    throw e
  }
}

const removeResearchLine = async({
  protocol,
  research_line,
  type,
}) => {
  try {
    return await axios.put(`/protocol/${protocol.id}/research-line`, {
      research_line,
      type,
    })
  } catch (e) {
    throw e
  }
}

const fetchProtocoloFunders = async(protocol) => {
  try {
    return await axios.get(`/protocol/${protocol.id}/funders`)
  } catch (e) {
    throw e
  }
}

const sendProtocolToDevelopment = async(payload) => {
  const {
          protocol,
          ...params
        } = payload
  
  try {
    return await axios.post(`/protocol/${protocol.id}/request/development`, {
      protocol_id: protocol.id,
      ...params,
    })
  } catch (e) {
    throw e
  }
}

const updateProtocolRealDates = async(payload) => {
  const {
          protocol,
          development,
          ...params
        } = payload
  
  try {
    return await axios.patch(
      `/protocol/${protocol.id}/development/${development.id}/dates`, {
        protocol_id: protocol.id,
        ...params,
      })
  } catch (e) {
    throw e
  }
}

const validateProtocolDevelopmentRequest = async(payload) => {
  const {
          protocol,
          development,
          ...params
        } = payload
  
  try {
    return await axios.patch(
      `/protocol/${protocol.id}/development/${development.id}/evaluation`, {
        protocol_id: protocol.id,
        ...params,
      })
  } catch (e) {
    throw e
  }
}

const fetchFinancingCommitments = async({ id }) => {
  try {
    return await axios.get(`/financing/commitments/${id}`)
  } catch (e) {
    throw e
  }
}

const fetchFinancingCommitment = async(payload) => {
  const {
    protocol,
    ...params
  } = payload

  try {
    return await axios.get(`/financing/commitments/${protocol}`, {
      params,
    })
  } catch (e) {
    throw e
  }
}

const addFinancingCommitment = async(payload) => {
  const {
          protocol,
          ...params
        } = payload
  
  try {
    return await axios.post(`/financing/commitment/${protocol.id}`, {
      ...params,
    })
  } catch (e) {
    throw e
  }
}

const editFinancingCommitment = async({id, ...params}) => {
  try {
    return await axios.put(`/financing/commitment/${id}`, {
      _method: 'PUT',
      ...params,
    })
  } catch (e) {
    throw e
  }
}

const completeFinancinCommitment = async(payload) => {
  try {
    return await axios.post(
      `/financing/commitment/${payload.get('commitment')}/complete`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  } catch (e) {
    throw e
  }
}

const rescheduleFinancinCommitment = async(payload) => {
  const {
          commitment,
          ...params
        } = payload
  
  try {
    return await axios.post(`/financing/commitment/${commitment}/reschedule`, {
      ...params,
    })
  } catch (e) {
    throw e
  }
}

const completeFinancingExtensionCommitment = async(payload) => {
  try {
    return await axios.post(
      `/financing/extension/commitment/${payload.get('commitment')}/complete`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  } catch (e) {
    throw e
  }
}

const rescheduleFinancingExtensionCommitment = async(payload) => {
  const {
          commitment,
          ...params
        } = payload
  
  try {
    return await axios.post(`/financing/extension/commitment/${commitment}/reschedule`, {
      ...params,
    })
  } catch (e) {
    throw e
  }
}

const updateCompletedFinancingExtensionCommitment = async(payload) => {
  try {
    return await axios.post(
      `/financing/extension/commitment/completed/${payload.get('commitment')}/update`,
      payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  } catch (e) {
    throw e
  }
}

const updateRescheduledFinancingExtensionCommitment = async(payload) => {
  const {
          commitment,
          overdueFinancingCommitment,
          ...params
        } = payload
  
  try {
    return await axios.post(
      `/financing/extension/commitment/rescheduled/${commitment}/${overdueFinancingCommitment}/update`,
      payload, {
        ...params,
      })
  } catch (e) {
    throw e
  }
}

const fetchResearchers = async(payload) => {
  const {
          protocol,
          status,
        } = payload
  
  try {
    return await axios.get(`/protocol/${protocol.id}/researchers`, {
      params: {
        status,
      },
    })
  } catch (e) {
    throw e
  }
}

const fetchBiosecurityQuestionnaire = async(payload) => {
  const { protocol } = payload
  
  try {
    return await axios.get(`/protocol/${protocol.id}/biosecurity/questionnaire`)
  } catch (e) {
    throw e
  }
}

/**
 *
 * @param payload
 * @returns {Promise<AxiosResponse<any>>}
 */
const saveBiosecurityQuestionnaire = async(payload) => {
  try {
    return await axios.post(
      `/protocol/${payload.get('protocol_id')}/biosecurity/questionnaire`,
      payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  } catch (e) {
    throw e
  }
}

const removeCommitment = async({
  protocol,
  commitment,
}) => {
  try {
    return await axios.delete(
      `/financing/${protocol.id}/commitment/${commitment}`)
  } catch (e) {
    throw e
  }
}

const dictateDeleteCommitment = async(payload) => {
  const {
    commitment,
    task,
    dictum,
    comments
  } = payload
  
  try {
    return await axios.post(`/financing/commitment/${commitment}/task/${task}`, {
        dictum,
        comments,
    })
  } catch (e) {
    throw e
  }
}

const dictateDeleteFinancingExtensionCommitment = async(payload) => {
  const {
    commitment,
    task,
    dictum,
    comments
  } = payload
  
  try {
    return await axios.post(`/financing/extension/commitment/${commitment}/task/${task}`, {
        dictum,
        comments,
    })
  } catch (e) {
    throw e
  }
}

const requestDeleteCommitment = async(payload) => {
  const {
    commitment,
    task,
    justification,
    dictum,
  } = payload
  
  try {
    return await axios.post(`/financing/commitment/${commitment}/task/${task}/delete`, {
      justification,
      dictum_id: dictum,
    })
  } catch (e) {
    throw e
  }
}

const requestDeleteFinancingExtensionCommitment = async(payload) => {
  const {
    commitment,
    task,
    justification,
    dictum,
  } = payload
  
  try {
    return await axios.post(`/financing/extension/commitment/${commitment}/task/${task}/delete`, {
      justification,
      dictum_id: dictum,
    })
  } catch (e) {
    throw e
  }
}

const fetchRPBIResearchers = async({
  protocol,
}) => {
  try {
    return await axios.get(`/protocol/${protocol.id}/researchers/rpbi`)
  } catch (e) {
    throw e
  }
}

const inviteResearchersByEmail = async(emails) => {
  try {
    return await axios.post(
      `/protocol/${protocol.id}/external/researchers/invite`, emails)
  } catch (e) {
    throw e
  }
}

const rejectResearcherInvitation = async(payload) => {
  try {
    const { invitation } = payload
    return await axios.post(
      `/api/protocol/external/researcher/invitation/${invitation.id}/reject`)
  } catch (e) {
    throw e
  }
}

const saveEthicsAttachments = async(payload) => {
  try {
    return await axios.post(
      `/protocol/${payload.get('protocol')}/ethics/attachments`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  } catch (e) {
    throw e
  }
}

const removeEthicsAttachment = async({
  protocol,
  file,
}) => {
  try {
    return await axios.delete(
      `/protocol/${protocol.id}/ethics/attachment/${file.id}`)
  } catch (e) {
    throw e
  }
}

const saveEthicsRenewalFormat = async(payload) => {
  try {
    return await axios.post(
      `/protocol/${payload.get('protocol')}/ethics/format`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  } catch (e) {
    throw e
  }
}

const fetchEthicsRenewalAttachments = async(payload) => {
  const { protocol } = payload
  
  try {
    return await axios.get(`/protocol/${protocol.id}/ethics/attachments`)
  } catch (e) {
    throw e
  }
}

const fetchEthicsRenewalDictums = async() => {
  try {
    return await axios.get(`/ethics-renewals/dictums`)
  } catch (e) {
    throw e
  }
}

const saveEthicsRenewalDictum = async(payload) => {
  try {
    return await axios.post(
      `/protocol/${payload.get('protocol')}/ethics/renewal/dictum`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  } catch (e) {
    throw e
  }
}

const updateFunderInformation = async(payload) => {
  try {
    return await axios.post(
      `/protocol/${payload.get('protocol')}/funder/${payload.get(
        'funder')}/update`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  } catch (e) {
    throw e
  }
}

const updateCompletedFinancinCommitment = async(payload) => {
  try {
    return await axios.post(
      `/financing/commitment/completed/${payload.get('commitment')}/update`,
      payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  } catch (e) {
    throw e
  }
}

const updateRescheduledFinancinCommitment = async(payload) => {
  const {
          commitment,
          overdueFinancingCommitment,
          ...params
        } = payload
  
  try {
    return await axios.post(
      `/financing/commitment/rescheduled/${commitment}/${overdueFinancingCommitment}/update`,
      payload, {
        ...params,
      })
  } catch (e) {
    throw e
  }
}

const saveFinalReportDictum = async(payload) => {
  try {
    return await axios.post(
      `/protocol/${payload.get('protocol')}/final-report/dictum/${payload.get(
        'type')}`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  } catch (e) {
    throw e
  }
}

const updateFinalReport = async(payload) => {
  try {
    return await axios.post(
      `/protocol/${payload.get('protocol')}/${payload.get('final_report_id')}/final-report/update`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  } catch (e) {
    throw e
  }
}

const requestRemoveCommitment = async({
  protocol,
  commitment,
  justification,
}) => {
  try {
    return await axios.post(
      `/protocol/${protocol.id}/financing/commitment/${commitment.financing_commitment_id}/delete`,
      {
        justification,
      })
  } catch (e) {
    throw e
  }
}

const requestRemoveExtensionCommitment = async({
  protocol,
  commitment,
  justification,
}) => {
  try {
    return await axios.post(
      `/protocol/${protocol.id}/financing/extension/commitment/${commitment.financing_commitment_id}/delete`,
      {
        justification,
      })
  } catch (e) {
    throw e
  }
}


const cancelProtocol = async(params) => {
  try {
    return await axios.post(`/protocol/${params.get('protocol_id')}/cancel`,
      params, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  } catch (e) {
    throw e
  }
}

const fetchProtocoloEvaluations = async({
  protocol,
  type,
}) => {
  try {
    return await axios.get(`/protocol/${protocol.id}/evaluations`, {
      params: {
        type,
      },
    })
  } catch (e) {
    throw e
  }
}

const fetchProtocolCommitteeDictums = async({ protocol }) => {
  try {
    return await axios.get(`/protocol/${protocol.id}/committee/dictums`)
  } catch (e) {
    throw e
  }
}

const fetchProtocolPendingTasks = async({ protocol }) => {
  try {
    return await axios.get(`/protocol/${protocol.id}/pending/tasks`)
  } catch (e) {
    throw e
  }
}

const fetchProtocolCommitteeAssignedReviewers = async({ protocol }) => {
  try {
    return await axios.get(`/protocol/${protocol.id}/committee/assigned-reviewers`)
  } catch (e) {
    throw e
  }
}

const fetchProtocolCommitteeMeetingDates = async({ protocol, committee }) => {
  try {
    return await axios.get(`/protocol/${protocol.id}/committee/${committee.id}/meeting-dates`)
  } catch (e) {
    throw e
  }
}

/**
 *
 * @param protocol
 * @param code
 * @returns {Promise<AxiosResponse<any>>}
 */
const saveUCPCodeProtocol = async({
  protocol,
  code,
}) => {
  try {
    return await axios.post(`/protocol/${protocol.id}/ucp-code/save`, {
      code,
    })
  } catch (e) {
    throw e
  }
}

/**
 *
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
const updateDictumFile = async(params) => {
  try {
    return await axios.post(
      `/protocol/${params.get('protocol_id')}/dictum/file`, params, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
  } catch (e) {
    throw e
  }
}

/**
 * Fetch advances from server.
 *
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
const fetchProtocolAdvances = async({ protocol }) => {
  try {
    return await axios.get(`/protocol/${protocol.id}/advances`)
  } catch (e) {
    throw e
  }
}

/**
 *
 * @param protocol
 * @returns {Promise<AxiosResponse<any>>}
 */
const fetchProtocolFinalReports = async({ protocol }) => {
  try {
    return await axios.get(`/protocol/${protocol.id}/final-reports/dictums`)
  } catch (e) {
    throw e
  }
}

/**
 *
 * @param protocol
 * @returns {Promise<AxiosResponse<any>>}
 */
const fetchProtocolRenewals = async({ protocol }) => {
  try {
    return await axios.get(`/protocol/${protocol.id}/ethics/renewals`)
  } catch (e) {
    throw e
  }
}

/**
 *
 * @param protocol
 * @returns {Promise<AxiosResponse<any>>}
 */
const fetchProtocolAdverseEvents = async({ protocol }) => {
  try {
    return await axios.get(`/protocol/${protocol.id}/adverse/events`)
  } catch (e) {
    throw e
  }
}

/**
 *
 * @param params
 * @returns {Promise<AxiosResponse<any>>}
 */
const fetchProtocols = async(params) => {
  try {
    return await axios.get(`/protocols`, {
      params,
    })
  } catch (e) {
    throw e
  }
}

const saveProtocolAdvances = async(payload) => {
  try {
    return await axios.post(`/protocol/${payload.get('protocol_id')}/${payload.get('committee_id')}/advances`, payload)
  } catch (e) {
    throw e
  }
}

const deleteProtocol = async({ protocol }) => {
  try {
    return await axios.delete(
      `/protocol/${protocol.id}`)
  } catch (e) {
    throw e
  }
}

const fetchFunderOrigins = async() => {
  try {
    return await axios.get(`/catalog/funders/origins`)
  } catch (e) {
    throw e
  }
}

const fetchFunderInstitutions = async() => {
  try {
    return await axios.get(`/catalog/funders/institutions`)
  } catch (e) {
    throw e
  }
}

const saveRequestedFunder = async(payload) => {
  try {
    return await axios.post(`/catalog/funders/request`, payload)
  } catch (e) {
    throw e
  }
}

export {
  addResearcher,
  cancelResearcherInvitation,
  cancelExternalResearcherInvitation,
  resendResearcherNotification,
  resendExternalResearcherNotification,
  reinviteResearcher,
  reinviteExternalResearcher,
  sendReplyToProtocol,
  sendLeaderEvaluation,
  sendDirectorEvaluation,
  fetchProtocolLeaderEvaluation,
  sendProtocolToEvaluationByLeader,
  saveProtocolFile,
  saveAmendmentFile,
  removeProtocolFile,
  removeAmendmentFile,
  fetchProtocolAttachments,
  saveProtocolAttachments,
  removeProtocolAttachment,
  saveFunders,
  removeFunder,
  saveFunderAgreement,
  saveFinancingInformation,
  fetchResearchLines,
  assignResearchLine,
  fetchProtocoloFunders,
  sendProtocolToDevelopment,
  updateProtocolRealDates,
  validateProtocolDevelopmentRequest,
  addFinancingCommitment,
  editFinancingCommitment,
  fetchFinancingCommitments,
  fetchFinancingCommitment,
  completeFinancinCommitment,
  rescheduleFinancinCommitment,
  completeFinancingExtensionCommitment,
  rescheduleFinancingExtensionCommitment,
  updateCompletedFinancingExtensionCommitment,
  updateRescheduledFinancingExtensionCommitment,
  fetchResearchers,
  removeResearchLine,
  fetchBiosecurityQuestionnaire,
  saveBiosecurityQuestionnaire,
  removeCommitment,
  dictateDeleteCommitment,
  dictateDeleteFinancingExtensionCommitment,
  requestDeleteCommitment,
  requestDeleteFinancingExtensionCommitment,
  fetchRPBIResearchers,
  inviteResearchersByEmail,
  rejectResearcherInvitation,
  saveEthicsAttachments,
  removeEthicsAttachment,
  saveEthicsRenewalFormat,
  fetchEthicsRenewalAttachments,
  updateFunderInformation,
  updateCompletedFinancinCommitment,
  updateRescheduledFinancinCommitment,
  fetchEthicsRenewalDictums,
  saveEthicsRenewalDictum,
  saveFinalReportDictum,
  requestRemoveCommitment,
  requestRemoveExtensionCommitment,
  cancelProtocol,
  fetchProtocoloEvaluations,
  fetchProtocolCommitteeDictums,
  fetchProtocolPendingTasks,
  fetchProtocolCommitteeAssignedReviewers,
  fetchProtocolCommitteeMeetingDates,
  saveUCPCodeProtocol,
  updateDictumFile,
  fetchProtocolAdvances,
  fetchProtocolFinalReports,
  fetchProtocolRenewals,
  fetchProtocolAdverseEvents,
  fetchProtocols,
  respondProtocolConditionedEvaluation,
  updateFinalReport,
  saveProtocolAdvances,
  deleteProtocol,
  fetchFunderOrigins,
  fetchFunderInstitutions,
  saveRequestedFunder,
}
